<app-header (filterChange)="onCategoryFilterChange($event)" (brandFilterChange)="onBrandFilterChange($event)"
  (openFilterChange)="onOpenFilterChange($event)" (searchFilterChange)="onSearchFilterChange($event)">
</app-header>

<section class="section grey-bg">
  <ul class="breadcrumb pdp-breadcrumb">

    <li *ngFor="let item of sortedCategoryHierarchy;let i=index">
      <span>{{ item.value }}</span>
      <i *ngIf="i!=sortedCategoryHierarchy.length-1" class="ri-arrow-right-s-line"></i>
    </li>

  </ul>

  <div class="product-detail-card">
    <div class="row2">
      <div class="col-30">
        <div class="carousel-container">
          <div class="carousel">
            <div class="slide" *ngFor="let image of msnDetails?.imagesUrls; let i = index"
              [ngClass]="{ 'active': i === selectedImageIndex }">
              <img [src]="imageprefix+image" alt="{{ image.caption }}">

            </div>
            <img class="img" *ngIf="msnDetails?.imagesUrls==null" src="../../../assets/img/NoImg.png" alt="" />
          </div>
          <div class="thumbnails">
            <button class="scroll-btn-2 scroll-left" *ngIf="checkOverflow(scrollContainer)" (click)="scrollLeft()"><i
                class="ri-arrow-left-s-line"></i></button>
            <div #scrollContainer class="overflow-list-2">
              <div *ngFor="let image of msnDetails?.imagesUrls; let i = index" class="thumbnail"
                (click)="selectImage(i)">
                <img [src]="imageprefix+image" alt="{{ image.caption }}">
              </div>
            </div>
            <button class="scroll-btn-2 scroll-right" *ngIf="checkOverflow(scrollContainer)" (click)="scrollRight()">
              <i class="ri-arrow-right-s-line"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-70">


<div class="msn-header">

<div class="d-flex align-items-center">
            <h1 class="m-0">{{ msnDetails?.msnId }}</h1>
            <span  class="copy-icon-button ml-10" (click)="copyToClipboard(msnDetails?.msnId, copyTooltip)"
              matTooltip="Copy MSN" #copyTooltip="matTooltip" matTooltipPosition="above">
                 <i class="ri-file-copy-line"></i>
            </span>
          </div>

<div class="show-supplier-green" *ngIf="supp">
            <button class="btn-primary" mat-raised-button color="warn" (click)="productSupplier(productId)">View
              supplier</button>
            <span class="tooltiptext">Supplier Available</span>

          </div>

          <div class="show-supplier-red" *ngIf="!supp">
            <button class="btn-primary" mat-raised-button color="warn">View supplier</button>
            <span class="tooltiptext">No supplier available</span>
          </div>


<div>
          <button mat-button
  class="btn-basic"
  color="Blue2"
  [disabled]="!msnDetails.documentInfo?.length"
  (click)="downloadDocument(msnDetails.documentInfo[0])">

  
  <span [class.text-grey]="!msnDetails.documentInfo?.length">
    <i class="ri-file-download-line icon-left"></i>
    Technical Document
  </span>
</button>
</div> 
</div>



<!-- 
        <div class="d-flex" style="margin-bottom: 11px;">

          <div class="d-flex align-items-center">
            <h1 class="m-0">{{ msnDetails?.msnId }}</h1>
            <span  class="copy-icon-button ml-10" (click)="copyToClipboard(msnDetails?.msnId, copyTooltip)"
              matTooltip="Copy MSN" #copyTooltip="matTooltip" matTooltipPosition="above">
                 <i class="ri-file-copy-line"></i>
            </span>
          </div>



          <div class="show-supplier-green" *ngIf="supp">
            <button class="btn-primary" mat-raised-button color="warn" (click)="productSupplier(productId)">View
              supplier</button>
            <span class="tooltiptext">Supplier Available</span>

          </div>

          <div class="show-supplier-red" *ngIf="!supp">
            <button class="btn-primary" mat-raised-button color="warn">View supplier</button>
            <span class="tooltiptext">No supplier available</span>
          </div>
 <div>
          <button mat-button
  class="btn-basic"
  color="Blue2"
  [disabled]="!msnDetails.documentInfo?.length"
  (click)="downloadDocument(msnDetails.documentInfo[0])">

  <i class="ri-file-download-line icon-left"></i>
  <span [class.text-grey]="!msnDetails.documentInfo?.length">
    Technical Document
  </span>
</button>
</div> 
        </div> -->

        <h2>{{ msnDetails?.productName }}</h2>
        <div class="product-price">
          <div class="d-flex">
            <h3 *ngIf="msnDetails?.mrpByCountry!=0">MRP- ₹{{getMRP(msnDetails?.mrpByCountry)}}</h3>
            <h3 *ngIf="msnDetails?.mrpByCountry==0">MRP- N/A</h3>
            <!-- <span class="gst ml-10" *ngIf="msnDetails?.priceList!=0">+ {{msnDetails?.tax_percentage}}% GST</span> -->
          </div>

          <span class="min-quantity">HSN- {{msnDetails?.hsn || 'N/A'}}</span>
          <span class="min-quantity">Tax(%) - {{ msnDetails?.tax_percentage || 'N/A'}}</span>
        </div>
        <div class="product-key-feature-card">
          <h4>KEY FEATURES <span *ngIf="!msnDetails?.featureList">:N/A</span></h4>
          <ul *ngFor="let feature of msnDetails?.featureList">
            <li>{{ feature }}</li>
          </ul>
          <h4>PRODUCT SPECIFICATIONS <span *ngIf="!msnDetails?.attributeMap">:N/A</span></h4>
          <table class="product-specification-table" *ngIf="showMore">
            <tr *ngFor="let specification of msnDetails?.attributeMap | keyvalue; let i = index">
              <td>{{ specification.key }}</td>
              <td>
                <ng-container *ngIf="specification.value.includes(',')">
                  <div *ngFor="let item of specification.value.split(',')">
                    {{ item.trim() }}
                  </div>
                </ng-container>
                <ng-container *ngIf="!specification.value.includes(',')">
                  {{ specification.value }}
                </ng-container>
              </td>
            </tr>
          </table>


          <!--<span *ngIf="item.label != 'Brand'"> {{ item.name }} </span>
                  <a *ngIf="item.label == 'Brand'" class="link">{{ item.name }}</a> !-->

          <table class="product-specification-table" *ngIf="!showMore">
            <tr *ngFor="let specification of msnDetails?.attributeMap | keyvalue; let i = index">
              <td *ngIf="i < 6">{{ specification.key }}</td>
              <td *ngIf="i < 6">
                <ng-container *ngIf="specification.value.includes(',')">
                  <div *ngFor="let item of specification.value.split(',')">
                    {{ item.trim() }}
                  </div>
                </ng-container>
                <ng-container *ngIf="!specification.value.includes(',')">
                  {{ specification.value }}
                </ng-container>
              </td>
            </tr>
          </table>


          <a *ngIf="shouldDisplayAnchor()" (click)="toggleTable()" class="link">{{ showMore ? 'Show Less' : 'Show More'
            }}</a>
        </div>

      </div>
    </div>

    <div class="varients-group-section pdp-varient-group" *ngIf="msnDetails?.cisGroupId">
      <div class="d-flex varients-group-header">
        <img class="mr-10" src="{{imageprefix}}{{expandedSingleGroupData[0]?.mainImageLink}}" alt=""
          onerror="this.src='../../../assets/img/NoImg.png'" />
        <div>
          <span>{{msnDetails?.brandName}}</span>
          <h2>{{expandedSingleGroupData[0]?.cisGroupName}} </h2>
        </div>
      </div>

      <div class="mog3_msnsearchtable product-varient-table-section" (scroll)="onScrollSingleGroup($event)">
        <table mat-table [dataSource]="expandedSingleGroupData" multiTemplateDataRows>
          <ng-container matColumnDef="MSNItemDescription">
            <th mat-header-cell *matHeaderCellDef class="border-right">
              MSN <br /> Item Description
            </th>
            <td mat-cell *matCellDef="let element" class="border-right">
              <div class="d-flex align-center justify-between">

              
              <span class="font-500 d-flex align-items-center">
                {{ element.moglixPartNumber }}
             
              </span>
              <span class="copy-icon-button"
                  (click)="copyToClipboardWithoutImpactOnTabExpantion(element?.moglixPartNumber, copyTooltip, $event)"
                  matTooltip="Copy MSN" #copyTooltip="matTooltip" matTooltipPosition="above">
                 <i  class="ri-file-copy-line"></i>
                </span>
                </div>
              <!-- <span class="link text-truncate"
              matTooltip="{{element?.productName}}"
                      [matTooltipPosition]="'right'"
                      matTooltipHideDelay="10">{{ element.productName }}
              </span> -->
              <div class="atom-tooltip">
                <span class="link text-truncate "> {{ element?.productName }}
                  <span class="atom-tooltiptext tooltip-right table-tooltip">{{ element?.productName }}</span>
                </span>
              </div>
            </td>
          </ng-container>

          <ng-container *ngFor="let column of dynamicColumnsForSingleGroup; let i= index" matColumnDef="{{column}}">
            <th mat-header-cell *matHeaderCellDef class="table-width-p71">
              <div class="flex items-center">
                {{capitalizeFirstLetterOfEachWord(column)}}
                <a mat-icon-button class="table-header-sort">
                  <i class="ri-arrow-up-down-fill"
                    (click)="displaySortedGroupDetails(msnDetails.cisGroupId,column)"></i>
                </a>
              </div>
            </th>
            <td mat-cell *matCellDef="let element" class="table-width-p71">
              {{ element?.attributeValuesForPart[column]}}
            </td>
          </ng-container>

          <ng-container matColumnDef="uom">
            <th mat-header-cell *matHeaderCellDef class="table-width-p80">Items in Pack <br /> UOM</th>
            <td mat-cell *matCellDef="let element" class="table-width-p80">
              {{element?.itemsInPack}}
              <span class="block">{{ element?.uom }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="MRP">
            <th mat-header-cell *matHeaderCellDef class="table-width-p76">
              MRP
              <br />
              <span _ngcontent-ydk-c178="" class="header-placeholder"> (dd/mm/yy)</span>
            </th>
            <td mat-cell *matCellDef="let element" class="table-width-p76">
              <span class="blue-text" *ngIf="element.mrp[selectedCountryName] && element.mrp[selectedCountryName] > 0">
                <strong> ₹{{ element?.mrp[selectedCountryName] }}</strong></span>
              <span class="blue-text" *ngIf="!element.mrp[selectedCountryName] || element.mrp[selectedCountryName]==0">
                <strong> - </strong></span>

              <br />
              {{ element?.mrpDateStr }}
            </td>
          </ng-container>

          <ng-container matColumnDef="listPrice">
            <th mat-header-cell *matHeaderCellDef class="table-width-p76">
              List Price
              <br />
              <div class="d-flex">
                <span class="header-placeholder">
                  (mm/dd/yy)</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let element" class="table-width-p76">
              <span class="blue-text" *ngIf="element.lp && element.lp > 0"> <strong> ₹{{ element?.lp }} </strong></span>
              <span class="blue-text" *ngIf="element.lp  ==null || element.lp == 0"> <strong> - </strong></span>

              <br />
              {{ element?.lpDate }}
            </td>
          </ng-container>

          <ng-container matColumnDef="TPTxn">
            <th mat-header-cell *matHeaderCellDef class="table-width-p76">
              TP Txn
              <br />
              <div class="d-flex">
                <span class="header-placeholder">
                  (yy/mm/dd)</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let element" class="table-width-p76">
              <span *ngIf="element['supplierAvailable']==true"> ₹{{ element['tp'] }} </span>
              <span *ngIf="element['supplierAvailable']!=true">-</span>
              <br />
              {{ element['txn_date'] }}
            </td>
          </ng-container>


          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
              <div class="example-element-detail" [@detailExpand]="
                element == expandedElement ? 'expanded' : 'collapsed'
              ">
                <div class="d-flex element-row w-100">
                  <div class="d-flex justify-between w-100">
                    <div class="d-flex mr-215">
                      <div class="example-element-diagram">
                        <img src="{{imageprefix}}{{element?.mainImageLink}}" alt=""
                          onerror="this.src='../../../assets/img/NoImg.png'" />
                      </div>
                      <div class="example-element-description item-detail-row">
                        <h2>{{ element?.productName }}</h2>
                        <div class="mrp-brand-section">
                          <span>MRP - ₹{{element?.mrp[selectedCountryName]}} | Brand -
                            <a class="blue-text cursor-pointer" (click)="navigateToBrandwiseCategory()">
                              {{capitalizeFirstLetterOfEachWord(element?.brandName)}} </a> </span>
                        </div>
                        <div class="hsn-info">
                          HSN- {{element?.productHsn}}, Tax - {{element?.taxPercentage}}%, Items in pack-
                          {{element?.itemsInPack}}
                        </div>
                        <div class="key-feature-list">
                          <span>Key Features</span>
                          <ul *ngIf="element?.keyFeatures?.length > 0">
                            <li>{{element?.keyFeatures[0]}}</li>
                            <ng-container
                              *ngIf="showAllKeyFeaturesForEachMsn[element?.moglixPartNumber]&& element?.keyFeatures?.length > 1">
                              <li *ngFor="let feature of element?.keyFeatures?.slice(1)">
                                {{ feature }}
                              </li>
                            </ng-container>
                          </ul>
                          <a class="see-more-btn" (click)="toggleKeyFeatures(element?.moglixPartNumber)"
                            *ngIf="element?.keyFeatures?.length > 0">
                            {{ showAllKeyFeaturesForEachMsn[element?.moglixPartNumber] ? 'See Less' : 'See More' }}
                          </a>
                        </div>
                      </div>
                    </div>

                    <div class="flex flex-col">
                      <button class="btn-primary mb-15" mat-raised-button color="warn"
                        (click)="openMsnPdpPage(element?.moglixPartNumber)">
                        View Product Details
                      </button>
                      <button class="btn-outline-primary mb-15" mat-stroked-button color="warn"
                        (click)="productSupplier(element['moglixPartNumber'])" [disabled]="!element.supplierAvailable">
                        <span *ngIf="element.supplierAvailable">View Suppliers</span>
                        <span *ngIf="!element.supplierAvailable">No Suppliers</span>
                      </button>
                                                 <button
  mat-button
  class="btn-basic"
  color="Blue2"
  [disabled]="!element.documentInfo?.length"
  (click)="downloadDocument(element.documentInfo[0])">

  <i class="ri-file-download-line icon-left"></i>
  <span [class.text-grey]="!element.documentInfo?.length">
    Technical Document
  </span>
</button>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let element; columns: displayedColumns" class="example-element-row"
            [class.example-expanded-row]="expandedElement === element" (click)="
            expandedElement =
              expandedElement === element ? null : element
          "></tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
        </table>
      </div>

    </div>
  </div>

</section>